import { Component, ViewChild } from '@angular/core';
import { NavController, Slides, NavParams, LoadingController, ToastController, Events } from 'ionic-angular';
import { UserData } from '../../providers/user';
import { AuthData } from '../../providers/auth';
import { EventData } from '../../providers/event';
import { Database } from '../../providers/database';
import { Translate } from '../../providers/translate';
import { NetworkProfilePage } from '../../pages/network-profile/network-profile';
import { NetworkContacts } from '../../pages/network-contacts/network-contacts';
import { EventProfilePage } from '../../pages/event-profile/event-profile';
import * as firebase from 'firebase';

@Component({
  selector: 'event-networking',
  templateUrl: 'event-networking.html'
})
export class EventNetworkingComponent {
  @ViewChild(Slides) slides: Slides;

  obsListener: any;
  obsContact: any;
  obsProfile: any;
  user: any;
  profiles: any;
  myProfiles: any;
  myProfile: any;
  callProfiles: any = [];
  componentState: any;
  event: any;
  client: any;
  isLoading: any = false;
  textTranslate: any;

  constructor(private nav: NavController, params: NavParams, public auth: AuthData, public userProvider: UserData, public eventProvider: EventData, public loadingCtrl: LoadingController, public db: Database, public toastCtrl: ToastController, translate: Translate, public events: Events) {
    translate.translateGroup(['Se ha enviado la solicitud de contacto'])
    .then(result => {
      this.textTranslate = result;
    });

    this.client = params.get('client');
    this.event = params.get('event');
    this.user = this.auth.getUser();

    this.isLoading = true;

    this.obsProfile = this.eventProvider.getUser(this.client, this.user.uid)
    .subscribe(result => {
      this.myProfile = result;
    });

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'networking').subscribe(stateModule => {
        if (stateModule.$value === true) {
          this.componentState = true;
          this.getNetworkingData();
        } else {
          this.callProfiles = false;
          this.componentState = false;
          this.initializeItems();

          console.log("Módulo Networking deshabilitado");
        }

      });

      // close de listener where logout user
      events.subscribe('client:logout', () => {
        this.closeListener();
        this.user = this.auth.getUser();
      });

      // close de listener where logout user
      events.subscribe('client:login', () => {
        this.user = this.auth.getUser();
        this.getNetworkingData();

        this.obsProfile = this.eventProvider.getUser(this.client, this.user.uid)
        .subscribe(result => {
          this.myProfile = result;
        });
      });
  }

  getNetworkingData() {
    if (this.componentState && !this.user.isAnonymous) {
      this.userProvider.getNetworking(this.client, this.user)
      .then((snapshot: any) => {
        this.userProvider.getMyContacts(this.client, this.user).then((result: any) => {
          if (result) {
            this.myProfiles = Object.keys(result).map(function (key) { return result[key]; });;
          } else {
            this.myProfiles = [];
          }

          snapshot.forEach(user => {
            let compare = this.myProfiles.filter((p) => {
              return (p.id.indexOf(user.val().id) > -1);
            });

            if (user.val().id != this.user.uid && compare.length == 0) {
              this.callProfiles.push(user.val());
            }
          });

          this.initializeItems();
        });
      });
    }
  }

  slideChanged() {
    console.log("Ending?", this.slides.isEnd())
  }

  viewProfile(profile) {
    this.nav.push(NetworkProfilePage, {client: this.client, event: this.event, dataProfile: profile});
  }

  viewMyProfile(profile) {
    this.nav.push(EventProfilePage, {client: this.client, event: this.event});
  }

  viewContacts() {
    this.nav.push(NetworkContacts, {client: this.client, event: this.event});
  }

  initializeItems() {
    this.profiles = this.callProfiles;
    this.isLoading = false;
  }

  getNetworking(ev: any) {
    this.initializeItems();

    let val = ev.target.value;

    if (val && val.trim() != '') {
      if (this.profiles) {
        this.profiles = this.profiles.filter((p) => {
          // this.slides.slideTo(0);
          return (p.networkingData.search.toLowerCase().indexOf(val.toLowerCase()) > -1);
        });
      }
    }
  }

  request(profile, key) {
    let loader = this.loadingCtrl.create();
    let myProfile = this.myProfile;
    delete(myProfile.$key);
    delete(myProfile.$exists);
    profile.networkingData.stateNetworking = 'sending';
    myProfile.networkingData.stateNetworking = 'pending';

    loader.present();

    this.db.updateData('/Clients/' + this.client.url + '/___NetworkingUsers/' + this.auth.getUser().uid + '/' + profile.id, profile).then(() => {
      this.db.updateData('/Clients/' + this.client.url + '/___NetworkingUsers/' + profile.id + '/' + this.auth.getUser().uid, this.myProfile).then(() => {
        // Increase counter user
        firebase.database().ref().child('/Clients/' + this.client.url + '/Users/' + profile.id + '/numRequestNetworking').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        // Increase counter dashboard
        firebase.database().ref().child('/Clients/' + this.client.url + '/___Dashboard/' + this.event.id + '/numRequestNetworking').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        let toast = this.toastCtrl.create({
          message: this.textTranslate['Se ha enviado la solicitud de contacto'],
          duration: 5000
        });
        this.myProfiles.push(profile);
        this.callProfiles.splice(key, 1);
        this.initializeItems();

        toast.present();
        loader.dismiss();
      });
    })
    .catch((error: any) => {
        let toast = this.toastCtrl.create({
          message: error,
          duration: 5000
        });
        loader.dismiss();
        toast.present();
    });
  }

  previousNetworking() {
    this.slides.slidePrev();
  }

  nextNetworking() {
    this.slides.slideNext();
  }

  closeListener() {
    if (this.obsListener) {
      console.log('Se eliminan los observables de Networking');
      this.obsListener.unsubscribe();
    }
    if (this.obsContact) {
      console.log('Se eliminan los observables de Networking');
      this.obsContact.unsubscribe();
    }
    if (this.obsProfile) {
      console.log('Se eliminan los observables de Networking');
      this.obsProfile.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// TODO: Load data for blocks
// end file



// WEBPACK FOOTER //
// ./src/components/event-networking/event-networking.ts